export enum NotificationType {
  NONE = 'none',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export interface NotificationState {
  toasts: ToastState[];
}

export interface SingleNotificationState {
  toast: ToastState | null;
}

export interface ToastState {
  id: string;
  title?: string;
  text: string;
  buttonLabel?: string;
  buttonLink?: string;
  type: NotificationType;
  newTab?: boolean;
  hasButton?: boolean;
}
